
import React from 'react'
import { LoginContext } from '../UserContext';
import { useNavigate } from "react-router-dom";
function OrderDetail() {
      const { user, login, logout, products, dispatch } =
    React.useContext(LoginContext);
    let GrandTotal = 0;
const navigate = useNavigate();
    function continueShopping()
    {
const action = {
      type: "START_SHOPPING",
      payload: null,
    };
        dispatch(action);
        navigate('/')
    }

  return (
    <div style={{display:'flex',flexDirection:'column' }}>
         <div
          className="Login_Header"
          style={{
            background: "#2874f0",
            paddingInline: 30,
            paddingBlock: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderBottom: "1px solid #ddd",
         
          }}
        >
       
          <h4
          
            style={{
              fontSize: "1.5em",
              color: "white",
              marginBlock: "0.5em",
            }}
          >
          Thank you for shopping with us
          </h4>

        </div>

   <h4
          
            style={{
              fontSize: "1.5em",
              color: "black",
              marginBlock: "1em",
              alignSelf:'center'
            }}
          >
          Your Order
          </h4>

 <div className="OrderDetails" style={{display:'flex',flexDirection:'column',border:'1px dashed black',width:'80%',alignSelf:'center',marginTop:10,padding:10    }}  >
 {products.map((product,index)=>{
GrandTotal+= product.price; 
     return(
 <div key={index} className="OrderProduct" style={{display:'flex',justifyContent:'space-between',alignItems:'center'  }}>
      <p style={{width:'80%'}}>{product.title}</p>
      <p>Rs {product.price}</p>
  </div>
     )
 } )}
  {console.log(products)}
 <div className='GrandTotal' style={{display:'flex',justifyContent:'space-between',alignItems:'center' }}>
      <h3>Grand Total</h3>
      <h3>Rs {GrandTotal}</h3>

 </div>
   
 </div>


  <button onClick={() =>continueShopping()  } style={{alignSelf:'center',marginTop:20,padding:10,color:'white',backgroundColor:'#fb641b',
    borderWidth: 0,
    fontWeight: 600  }}>
      Continue Shopping
  </button>
    </div>
  )
}

export default OrderDetail